import { useNavigation } from "@react-navigation/native";
import React from "react";
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import {
  wallet_success,
  wallet_failure,
  timer_icon,
} from "../../../utils/images";
import MergeShareSuccess from "../../portfolio/childComponents/mergeShareSuccess";
import {
  trackMoengageEvent,
  isMobile,
  timeSinceCurrentTime,
} from "../../../utils/commonMethods";
import FastImage from "../../../common/FastImage";
import { navigationReset } from "../../../navigation/rootNavigation";
import Colors from "../../../assets/Color/Colors";
import { globalConst } from "../../../utils/globalConstant";
import TimerComp from "../../../commonComponents/TimerComp";

const ContestStatus = ({ onDoneClick, apiRespnseUiData }) => {
  const navigation = useNavigation();

  let success = apiRespnseUiData?.success;

  let btnText = success
    ? "Done"
    : apiRespnseUiData?.code === 424
    ? "Add " + apiRespnseUiData?.required?.toString()
    : "Retry";

  const handleActions = () => {
    if (apiRespnseUiData?.code === 424) {
      if (isMobile()) {
        navigation.push("WalletStack", {
          screen: "WalletAdd",
          params: {
            rechargeAmount: apiRespnseUiData?.required?.toString(),
          },
        });
      } else {
        navigation.navigate("Wallet", {
          rechargeAmount: apiRespnseUiData?.required?.toString(),
        });
      }
    }
    onDoneClick();
  };

  return (
    <View style={{ flex: 1, paddingBottom: 10, paddingHorizontal: 15 }}>
      <View
        style={{
          width: isMobile() ? Width.width - 30 : "auto",
          flex: 1,
        }}
      >
        <View>
          <FastImage
            style={{
              width: 90,
              height: 90,
              alignSelf: "center",
              marginBottom: 10,
            }}
            source={success ? wallet_success() : wallet_failure()}
          ></FastImage>

          <Text style={[styles.orderStatusText]}>
            {apiRespnseUiData?.title}
          </Text>

          {apiRespnseUiData?.info ? (
            <Text style={styles.failedOrderText}>
              <Text
                style={{
                  color: Colors.lightgrey,
                }}
              >
                {apiRespnseUiData?.info}
              </Text>
            </Text>
          ) : null}
        </View>
        <View style={[globalStyle.customBtnParentModalStyle]}>
          {apiRespnseUiData?.start_time || apiRespnseUiData?.end_time ? (
              <TimerComp start_time={apiRespnseUiData?.start_time} end_time={apiRespnseUiData?.end_time} isHome={'contest'}  customStyle={styles.timerIndicator}/>
          ) : (
            <View style={{ height: 30 }} />
          )}
          <CustomButton
            btnText={btnText}
            btnType={"btnBlack"}
            onBtnClick={() => {
              setTimeout(() => {
                handleActions();
              }, globalConst?.buttonTimer);
            }}
            translate={true}
          />
        </View>
      </View>
    </View>
  );
};

export default ContestStatus;

const styles = StyleSheet.create({
  orderStatusText: {
    ...globalFontStyle.appFontTitle,
    alignSelf: "center",
    marginBottom: 20,
    textAlign: "center",
    color: Color.black,
  },
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: Color.black,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 0.75,
    borderColor: Colors.borderColor,
    paddingHorizontal: 18,
    paddingVertical: 15,
  },
  tableContainer: {
    borderWidth: 0.75,
    borderColor: Colors.borderColor,
    borderRadius: 10,
    //paddingHorizontal: 18,
    marginBottom: 45,
  },

  failedOrderText: {
    ...globalFontStyle.appFontSubText,
    color: Color.grey2,

    textAlign: "center",
  },
  timerIndicator: {
    borderRadius: 5,
    backgroundColor: "rgba(10, 87, 255, 0.10)",
    paddingVertical: 10,
    alignItems: "center",
    marginBottom: 15,
    flexDirection: "row",
    justifyContent: "center",
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
  tipTimerTestStyle: {
    ...globalFontStyle.appFontSubText,
    color: Color.blue1,
  },
});
